import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './routes';
import { initializeI18next } from './plugins/i18next';
import { Provider } from 'react-redux';
import { StyledEngineProvider, ThemeProvider, useTheme } from '@mui/material/styles';
import store from './store';
import { useDispatch, useSelector } from '@store';
import { setScreenSizeAction } from '@reducers/global';
import { useMediaQuery } from '@mui/material';
import { HIVE_API_DOMAIN, LINC_API_DOMAIN } from '@constants/api'; // import { firestore } from "@lib/firebase";
import { jsx as _jsx } from "react/jsx-runtime";
function useWidth() {
    const theme = useTheme();
    const keys = [...theme.breakpoints.keys].reverse();
    return keys.reduce((output, key) => {
        const matches = useMediaQuery(theme.breakpoints.up(key));
        return !output && matches ? key : output;
    }, null) || 'xs';
}
function App() {
    const dispatch = useDispatch();
    const theme = useTheme();
    const width = useWidth();
    const { vrtype } = useSelector(state => state.global); // domain이 vvidcall-smartsocial-95816.web.app 일 경우 view.lincshare.co.kr로 redirect
    useEffect(() => { const hostname = window.location.hostname; const pathname = window.location.pathname; const search = window.location.search; const ssUrl = vrtype === 'HIVE' ? "https://view.".concat(HIVE_API_DOMAIN) : "https://view.".concat(LINC_API_DOMAIN); if (hostname === 'vvidcall-smartsocial-95816.web.app') {
        window.location.href = ssUrl + pathname + search;
    } }, []);
    useEffect(() => { initializeI18next(); let vh = window.innerHeight * 0.01; document.documentElement.style.setProperty('--vh', "".concat(vh, "px")); const setCustomVh = () => { document.documentElement.style.setProperty('--vh', window.innerHeight / 100 + 'px'); }; window.addEventListener('resize', setCustomVh); return () => { window.removeEventListener('resize', setCustomVh); }; }, []); // 스크린 사이즈 및 화면 방향 정보 저장
    useEffect(() => { dispatch(setScreenSizeAction(width, window.screen.orientation)); }, [document.body.clientWidth]);
    return /*#__PURE__*/ _jsx(BrowserRouter, { children: /*#__PURE__*/ _jsx(Provider, { store: store, children: /*#__PURE__*/ _jsx(StyledEngineProvider, { injectFirst: true, children: /*#__PURE__*/ _jsx(ThemeProvider, { theme: theme, children: /*#__PURE__*/ _jsx(AppRouter, {}) }) }) }) });
}
export default App;
